<template>
    <div class="medical-column-detail">
        <HomeSkeleton style="margin-top: 20px;margin-bottom: 100vh" v-if="isLoading"></HomeSkeleton>
        <div v-else>
            <div class="header-wrapper" v-if="pageInfo">
                <div class="header-wrapper-box">
                    <van-image v-if="pageInfo && pageInfo.logo" :src="pageInfo.logo" />
                    <div class="header-wrapper-box-info">
                        <div class="header-wrapper-box-title">
                            {{ pageInfo.title }}
                        </div>
                        <div class="header-wrapper-box-tags">
                            <div><span>{{ pageInfo.current_count }}</span>内容</div>
                            <div><span>{{ pageInfo.subscribe_count }}</span>关注</div>
                            <div><span>{{ pageInfo.view_count }}</span>人阅读</div>
                        </div>
                        <div class="header-wrapper-box-desc" v-if="pageInfo.desc">
                            {{ pageInfo.desc }}
                        </div>
                    </div>
                    <van-button type="primary" v-if="!pageInfo.is_subscribe" @click.stop="handleStatus(pageInfo)">
                        <img src="@/assets/medical/medical-follow.svg" />
                        关注
                    </van-button>
                    <van-button v-else @click.stop="handleStatus(pageInfo)">
                        <img src="@/assets/medical/medical-follow.svg" />
                        已关注
                    </van-button>
                </div>
            </div>

            <div class="medical-column-detail-list" v-if="channelList !== null && channelList && channelList.length">
                <van-list v-if="channelList" @load="onLoad">
                    <div v-for="(item, index) in channelList" :key="item.id">
                        <Article :dataItem="item" :wapperFn="true" @goDetail="goDetail(item)" />
                        <van-divider v-if="index !== channelList.length - 1" />
                    </div>
                </van-list>
            </div>
            <van-empty v-else description="" image="/static/img/pic_blank_content.svg">
                <template slot="description">
                    <div style="text-align: center">没有更多了</div>
                    <div style="text-align: center">博医荟持续更新中…</div>
                    <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                    <div style="text-align: center;margin-top: 24px">
                        <van-button color="#D3172E" round size="small" style="width: 120px" :to="'/'">
                            返回首页
                        </van-button>
                    </div>
                </template>
            </van-empty>
        </div>

        <Back></Back>
    </div>
</template>

<script>
import Interface from '@/util/interface'
import Article from '../components/article.vue'
import HomeSkeleton from '@/skeleton/homeSkeleton'
import Back from '@/components/back'

export default {
    components: {
        Article,
        HomeSkeleton,
        Back
    },
    data() {
        return {
            loading: true,
            finished: false,
            isLoading: false,
            channelList: [],
            page: {
                page: 1,
                pageSize: 999
            },
            total: 0,
            pageInfo: {},
            type: false,
            pageID: null,
            isFirstEnter: false,
            busy:false,
        }
    },
    methods: {
        handleStatus(row) {
            if (!row.is_subscribe) {
                this.pageID = row.id
                this.fetch('subscribe')
                return
            }
            this.$dialog
                .confirm({
                    title: '提醒',
                    message: '确定取消关注吗？',
                    confirmButtonText: '确定',
                    className: 'dly-dialog'
                })
                .then(() => {
                    this.type = true
                    this.pageID = row.id
                    this.fetch('subscribe')
                })
                .catch(() => {
                    console.log(1)
                })
        },
        goDetail(row) {
            this.$router.push({
                name: 'medical-column-detail',
                params: { id: row.id }
            })
        },
        onLoad() {
        },
        fetch(scene, flag) {
            if (scene === 'pageInfo') {
                Interface.getData('get', Interface.medical.detailinfo + this.$route.params.id).then(res => {
                    if (!flag) {
                        this.pageInfo = res.data
                    } else {
                        this.pageInfo.subscribe_count = res.data.subscribe_count
                        this.pageInfo.is_subscribe = res.data.is_subscribe
                    }
                })
            } else if (scene === 'channelList') {
                if(this.busy){
                    return false
                }
                this.busy = true
                Interface.getData('get', Interface.medical.followList + this.$route.params.id, { ...this.page, content_type: 30 }).then(res => {
                    this.busy = false
                    setTimeout(() => {
                        this.isLoading = false
                    }, 500)

                    if (res.data.list === null) {
                        this.finished = true
                        return
                    }
                    if (flag) {
                        this.channelList.push(...res.data.list)
                    } else {
                        this.channelList = res.data.list
                    }
                    this.loading = false

                    if (this.channelList.length >= res.data.total) {
                        this.finished = true
                    }
                })
            } else if (scene === 'subscribe') {
                Interface.getData('get', Interface.medical.subscribe + this.pageID).then(res => {
                    if (res.code === 0) {
                        if (this.type) {
                            this.$toast.success('取消关注成功')
                            this.type = false
                            this.pageID = null
                        } else {
                            this.$toast.success('关注成功')
                        }
                        this.fetch('pageInfo', true)
                    } else {
                        this.$toast(res.message)
                    }
                })
            }
        }
    },
    created() {
        this.fetch('pageInfo', false)
        this.fetch('channelList', false)
        let source_type = Interface.getUrl(window.location.href)
        if (source_type) {
            Interface.mFootPrint(this.$route.params.id, 30,2, '', source_type, '医学专栏')
        } else {
            Interface.mFootPrint(this.$route.params.id,30,2,'',0,'医学专栏')
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>

<style lang="scss">
// 自定义弹出框的内容
.dly-dialog {
    width: 270px;
    height: 164px;
    background: #ffffff;
    border-radius: 8px;
    padding-bottom: 5px;

    .van-dialog__header {
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
        line-height: 22px;
        padding-top: 20px;
        padding-bottom: 12px;
    }

    .van-dialog__content .van-dialog__message {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #404040;
        line-height: 20px;
        margin-bottom: 30px;
        padding: 0px;
    }

    .van-dialog__footer {
        padding: 0px 29px 0px 29px;

        .van-dialog__cancel {
            .van-button__content {
                width: 100px;
                height: 40px;
                background: #f7f7f7;
                border-radius: 20px;
                margin: 0 auto;
                padding: 0px;

                .van-button__text {
                    font-size: 14px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #999999;
                    line-height: 20px;
                }
            }
        }

        .van-dialog__confirm {
            .van-button__content {
                width: 100px;
                height: 40px;
                background: #d3172e;
                border-radius: 20px;
                margin: 0 auto;
                margin-left: 12px;

                .van-button__text {
                    font-size: 14px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #ffffff;
                    line-height: 20px;
                }
            }
        }
    }

    .van-dialog__cancel {
        border: none;
        text-align: center;
    }

    .van-hairline--top::after {
        border: none;
    }

    .van-hairline--left::after {
        border: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/medical-column/list/index.vue